import { ArrowRight } from "lucide-react";

const ROLES = [
  "Music Artist", "Audio Engineer", "Photographer", "Creative Director", "Project Manager", "Entrepreneur",
];

export default function Hero() {
  return (
    <section className="relative min-h-[100vh] flex items-end bg-charcoal text-warmwhite overflow-hidden" data-testid="hero-section">
      <img
        src="https://images.unsplash.com/photo-1627407660893-fe01f60d44c4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwyfHxtdXNpYyUyMHByb2R1Y2VyJTIwc3R1ZGlvJTIwcmVjb3JkaW5nJTIwbWluaW1hbHxlbnwwfHx8fDE3ODI3NzYwMzR8MA&ixlib=rb-4.1.0&q=85"
        alt="Studio session"
        className="absolute inset-0 w-full h-full object-cover opacity-70"
      />
      <div className="absolute inset-0 hero-mask" />

      {/* Top label */}
      <div className="absolute top-28 left-6 md:left-12 right-6 md:right-12 flex items-center justify-between z-10">
        <p className="text-[11px] uppercase tracking-widest-custom text-gold reveal-up" data-testid="hero-eyebrow">A portfolio by James Douglas</p>
        <p className="hidden md:block text-[11px] uppercase tracking-widest-custom text-warmwhite/60">Est. Florida · Worldwide</p>
      </div>

      <div className="relative z-10 max-w-[1400px] mx-auto px-6 md:px-12 pb-20 md:pb-28 w-full">
        <div className="max-w-5xl">
          <h1 className="font-serif text-[44px] sm:text-6xl md:text-7xl lg:text-[104px] font-light leading-[0.95] tracking-tighter reveal-up" data-testid="hero-headline" style={{ animationDelay: "120ms" }}>
            Creating experiences <span className="italic text-gold">that inspire.</span>
            <br />
            <span className="text-warmwhite/85">Building brands</span> <span className="italic">that last.</span>
          </h1>

          <p className="mt-10 max-w-2xl text-base md:text-lg text-warmwhite/75 leading-relaxed reveal-up" data-testid="hero-sub" style={{ animationDelay: "260ms" }}>
            A multidisciplinary creative practice across music, photography, audio engineering, and entrepreneurship — rooted in faith and obsessed with the work.
          </p>

          <div className="mt-12 flex flex-col sm:flex-row gap-4 reveal-up" style={{ animationDelay: "400ms" }}>
            <a href="#work" className="group inline-flex items-center justify-center gap-3 bg-warmwhite text-charcoal px-9 py-5 text-[11px] uppercase tracking-widest-custom hover:bg-gold transition-colors duration-300" data-testid="hero-cta-explore">
              Explore my work
              <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
            </a>
            <a href="#booking" className="inline-flex items-center justify-center border border-warmwhite/60 text-warmwhite px-9 py-5 text-[11px] uppercase tracking-widest-custom hover:bg-warmwhite hover:text-charcoal transition-all duration-300" data-testid="hero-cta-book">
              Book a consultation
            </a>
          </div>
        </div>
      </div>

      {/* Marquee */}
      <div className="absolute bottom-0 left-0 right-0 border-t border-warmwhite/15 bg-charcoal/60 backdrop-blur-sm py-5 overflow-hidden z-10">
        <div className="marquee flex gap-16 whitespace-nowrap will-change-transform">
          {[...ROLES, ...ROLES, ...ROLES].map((r, i) => (
            <span key={i} className="font-serif italic text-2xl md:text-3xl text-warmwhite/55">
              {r}
              <span className="ml-16 text-gold not-italic">•</span>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
